import { ArticleOrderDraft, ItemOrderDraft } from '../../../domain/Order';

export default (from: ArticleOrderDraft[], to: ArticleOrderDraft[]): ArticleOrderDraft[] =>
    from.reduce((result: ArticleOrderDraft[], articleToCopy: ArticleOrderDraft) => {
        const existingArticle: ArticleOrderDraft | undefined = to.find((a: ArticleOrderDraft) => a.articleId === articleToCopy.articleId);
        if (existingArticle) {
            return [
                ...result,
                {
                    ...articleToCopy,
                    itemsOrdersDrafts: articleToCopy.itemsOrdersDrafts.reduce((re: [], itemToCopy: ItemOrderDraft): ItemOrderDraft[] => {
                        const existingItem: ItemOrderDraft | undefined = existingArticle.itemsOrdersDrafts.find(
                            (a: ItemOrderDraft) => a.sku === itemToCopy.sku
                        );
                        if (existingItem) {
                            return [
                                ...re,
                                {
                                    ...itemToCopy,
                                    toOrderFromEstimation: itemToCopy.toOrderFromEstimation,
                                    toOrderFromStock: existingItem.toOrderFromStock
                                }
                            ];
                        } else {
                            return [...re, itemToCopy];
                        }
                    }, notExistingItems(existingArticle.itemsOrdersDrafts, articleToCopy.itemsOrdersDrafts))
                }
            ];
        } else {
            return [...result, articleToCopy];
        }
    }, notExistingArticles(to, from));

const notExistingItems = (to: ItemOrderDraft[], from: ItemOrderDraft[]): ItemOrderDraft[] =>
    to.filter((i1: ItemOrderDraft) => from.find((i2: ItemOrderDraft) => i2.sku === i1.sku) === undefined).map(removeStockFromItems);

const notExistingArticles = (to: ArticleOrderDraft[], from: ArticleOrderDraft[]): ArticleOrderDraft[] =>
    to
        .filter((t: ArticleOrderDraft) => from.find((f: ArticleOrderDraft) => f.articleId === t.articleId) === undefined)
        .map((t: ArticleOrderDraft) => ({
            ...t,
            itemsOrdersDrafts: t.itemsOrdersDrafts.map(removeStockFromItems)
        }));

const removeStockFromItems = (i: ItemOrderDraft): ItemOrderDraft => ({
    ...i,
    toOrderFromEstimation: 0
});



// WEBPACK FOOTER //
// ./src/application/order/reducer/applyEstimationLevels.ts